module.exports = __webpack_public_path__ + "static/media/icon_download_report.0e82dbb9.svg";